module.exports = __webpack_public_path__ + "static/img/msig.aa6ca7ea.png";